module.exports = __webpack_public_path__ + "static/media/img_device.7de55283.png";